<div class="modal fade document-file-picker" [id]="modalId()" msEscClose (escPressed)="cancel()"
    data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xl">
        <div class="modal-content">
            <div class="modal-header border-0 p-4">
                <h5 class="modal-title">{{ title() }}</h5>
            </div>

            <div class="modal-body px-4 pb-0">
                <p class="text-secondary small mb-3">{{ helpText() }}</p>

                <div class="row g-3">

                    <!-- Folders -->
                    <div class="col-md-5">
                        <label class="form-label small text-muted mb-1">Folders</label>
                        @if (isLoadingFolders()) {
                            <div class="d-flex align-items-center gap-2 text-muted small py-2">
                                <span class="spinner-border spinner-border-sm"></span> Loading folders…
                            </div>
                        } @else {
                            <ms-folder-tree-picker
                                [rootNodes]="rootFolders()"
                                [loadChildren]="loadChildren"
                                [(selected)]="selectedFolder"
                                [showRoot]="false"
                                emptyMessage="No folders available." />
                        }
                    </div>

                    <!-- Files -->
                    <div class="col-md-7">
                        <label class="form-label small text-muted mb-1">Files</label>
                        <div class="file-list border rounded">
                            @if (!hasFolderSelected()) {
                                <p class="text-muted small text-center py-4 mb-0">Select a folder to see its files.</p>
                            } @else if (isLoadingFiles()) {
                                <div class="d-flex align-items-center justify-content-center gap-2 text-muted small py-4">
                                    <span class="spinner-border spinner-border-sm"></span> Loading files…
                                </div>
                            } @else if (files().length === 0) {
                                <p class="text-muted small text-center py-4 mb-0">This folder has no matching files.</p>
                            } @else if (layout() === 'grid') {

                                <!-- Thumbnail grid (image-picker preview) -->
                                <div class="row g-2 row-cols-2 row-cols-sm-3 p-2 m-0">
                                    @for (file of files(); track file.documentNodeId) {
                                        <div class="col">
                                            <button type="button" class="picker-card w-100 h-100"
                                                [class.selected]="isSelected(file)"
                                                [disabled]="!isSelectable(file)"
                                                (click)="selectFile(file)">
                                                <span class="picker-thumb">
                                                    @if (thumbnailUrl(file); as url) {
                                                        <img [src]="url" [alt]="file.name" loading="lazy" class="picker-thumb-img" />
                                                    } @else {
                                                        <fa-duotone-icon [icon]="fileIcon(file)" secondaryOpacity="0.9" class="picker-thumb-icon" />
                                                    }
                                                    @if (!isSelectable(file)) {
                                                        <span class="badge text-bg-light picker-thumb-badge">
                                                            {{ file.status === DocumentStatus.Quarantined ? 'Quarantined' : 'Scanning' }}
                                                        </span>
                                                    }
                                                </span>
                                                <span class="picker-card-name d-block text-truncate small mt-1">{{ file.name }}</span>
                                                <span class="picker-card-size d-block text-muted">{{ formatBytes(file.sizeBytes) }}</span>
                                            </button>
                                        </div>
                                    }
                                </div>
                                @if (hasMoreFiles()) {
                                    <p class="text-muted small text-center py-2 mb-0">
                                        Showing the first {{ files().length }} files. Open a subfolder to narrow down.
                                    </p>
                                }

                            } @else {

                                <div class="list-group list-group-flush">
                                    @for (file of files(); track file.documentNodeId) {
                                        <button type="button"
                                            class="list-group-item list-group-item-action d-flex align-items-center gap-2"
                                            [class.active]="isSelected(file)"
                                            [disabled]="!isSelectable(file)"
                                            (click)="selectFile(file)">
                                            <fa-duotone-icon icon="file" secondaryOpacity="0.9" />
                                            <span class="text-truncate flex-grow-1 text-start">{{ file.name }}</span>
                                            @if (!isSelectable(file)) {
                                                <span class="badge text-bg-light">
                                                    {{ file.status === DocumentStatus.Quarantined ? 'Quarantined' : 'Scanning' }}
                                                </span>
                                            }
                                            <span class="small text-muted">{{ formatBytes(file.sizeBytes) }}</span>
                                        </button>
                                    }
                                </div>
                                @if (hasMoreFiles()) {
                                    <p class="text-muted small text-center py-2 mb-0">
                                        Showing the first {{ files().length }} files. Open a subfolder to narrow down.
                                    </p>
                                }

                            }
                        </div>
                    </div>

                </div>
            </div>

            <div class="modal-footer border-0 d-flex justify-content-center pb-4 gap-2">
                <button type="button" class="btn btn-ms-secondary px-4" (click)="cancel()">Cancel</button>
                <button type="button" class="btn btn-primary px-4" (click)="confirm()" [disabled]="!canConfirm()">
                    {{ confirmLabel() }}
                </button>
            </div>
        </div>
    </div>
</div>
